import { render, staticRenderFns } from "./controlRoomUPSBar.vue?vue&type=template&id=f510e25a&scoped=true&"
import script from "./controlRoomUPSBar.vue?vue&type=script&lang=js&"
export * from "./controlRoomUPSBar.vue?vue&type=script&lang=js&"
import style0 from "./controlRoomUPSBar.vue?vue&type=style&index=0&id=f510e25a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f510e25a",
  null
  
)

export default component.exports